<template>
  <router-view />
</template>

<script>
export default {
  mounted(){
    this.emitter.on('sendAnalyticsEvent', function({ event = null, parameters = null }){
      if(this.$analytics && event){
          this.$analytics.logEvent(event, parameters);
      }
    }.bind(this));
    this.emitter.on('sendAnalyticsView', function({ screen_name = "Sem Nome" }){
      document.title = screen_name + " - " + import.meta.env.VITE_PAGE_TITLE;
      if(this.$analytics){
          this.$analytics.logEvent("screen_view", {
              app_name: "web",
              screen_name: screen_name,
              app_version: import.meta.env.VITE_VERSION_PROJECT
          });
      }
    }.bind(this));
  }
}
</script>